import React, { useContext, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import {
  mdiBookVariantMultiple,
  mdiCalendarRange,
  mdiClipboardCheck,
  mdiClipboardText,
  mdiClockTimeNineOutline,
  mdiFolderOutline,
} from '@mdi/js';
import { v4 as uuid } from 'uuid';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import DatePicker from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import { connect } from 'react-redux';
import MemoBox from '../Memo/components/MemoBox';
import WeekCalendar from './components/WeekCalendar';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../redux/actions/loadingActions';
import GraphQl from '../../GraphQL';
import { schoolWorkingDays } from '../../shared/queries/SchoolData';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import ClassDiary from '../ClassDiary';
import Communication from '../Communication';
import {
  COMMUNICATION_TYPE,
  TEACHER_ROOM_OPTION_TYPE,
} from '../../shared/utils/constants';
import { professorScheduleGridByDateAndId } from '../../shared/queries/TeacherRoom';
import CycleClosing from '../CycleClosing';
import SmartContext from '../App/context/SmartContext';
import {
  employeeListActive,
  getEmployeeIsAdmin,
} from '../../shared/queries/Employee';
import OptionsSelection from '../../shared/components/form/OptionsSelection';

const TeachersRoom = (props) => {
  const context = useContext(SmartContext);
  const { t, history, dispatch } = props;
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTeacher, setSelectedTeacher] = useState();
  const [schoolOpeningHours, setSchoolOpeningHours] = useState({});
  const [showWeekCalendar, setShowWeekCalendar] = useState(true);
  const [showClassPlan, setShowClassPlan] = useState(false);
  const [showOccurrences, setShowOccurrences] = useState(false);
  const [showClassDiary, setShowClassDiary] = useState(false);
  const [showActivities, setShowActivities] = useState(false);
  const [showCycleClosure, setShowCycleClosure] = useState(false);
  const [showByTeacherFilter, setshowByTeacherFilter] = useState(false);
  const [events, setEvents] = useState([]);
  const { teacherRoomMemoBox, setTeacherRoomMemoBox } = context;
  const [teachers, setTeachers] = useState([]);
  const [employeeIsAdmin, setemployeeIsAdmin] = useState(false);
  const memoBoxes = [
    {
      icon: <Icon path={mdiClockTimeNineOutline} />,
      title: t('teachers-room.inbox-title-grade'),
      route: '/minime/grade-horario',
      type: TEACHER_ROOM_OPTION_TYPE.GRADE,
      more: false,
    },
    {
      icon: <Icon path={mdiClipboardText} />,
      title: t('teachers-room.inbox-title-occurrences'),
      route: '/minime/postagem/mnt/OCCU/0',
      type: TEACHER_ROOM_OPTION_TYPE.OCCURRENCE,
      more: true,
    },
    {
      icon: <Icon path={mdiBookVariantMultiple} />,
      title: t('teachers-room.inbox-title-class-plan'),
      route: '/minime/plano-aula/mnt/0',
      type: TEACHER_ROOM_OPTION_TYPE.PLAN,
      more: true,
    },
    {
      icon: <Icon path={mdiFolderOutline} />,
      title: t('teachers-room.inbox-title-class-diary'),
      route: '/minime/diario-classe/mnt/0',
      type: TEACHER_ROOM_OPTION_TYPE.DIARY,
      more: true,
    },
    {
      icon: <Icon path={mdiClipboardCheck} />,
      title: t('teachers-room.inbox-title-evaluative-activities'),
      route: '/minime/postagem/mnt/EXAM/0',
      type: TEACHER_ROOM_OPTION_TYPE.ACTIVITY,
      more: true,
    },
    {
      icon: <Icon path={mdiCalendarRange} />,
      title: t('teachers-room.inbox-title-cycle-closure'),
      route: '/minime/consolidacao-ciclo/mnt/0',
      type: TEACHER_ROOM_OPTION_TYPE.CYCLE,
      more: true,
    },
  ];

  const setView = (item) => {
    const date = new Date();
    setTeacherRoomMemoBox(item.type);
    let showWeekCalendarView = false;
    let showClassPlanView = false;
    let showOccurrencesView = false;
    let showClassDiaryView = false;
    let showActivitiesView = false;
    let showCycleClosureView = false;
    if (showByTeacherFilter) {
      // eslint-disable-next-line no-use-before-define
      loadEventsByDate(date);
      setshowByTeacherFilter(false);
    }
    switch (item.type) {
      case TEACHER_ROOM_OPTION_TYPE.GRADE:
        showWeekCalendarView = true;
        break;
      case TEACHER_ROOM_OPTION_TYPE.OCCURRENCE:
        showOccurrencesView = true;
        break;
      case TEACHER_ROOM_OPTION_TYPE.PLAN:
        showClassPlanView = true;
        break;
      case TEACHER_ROOM_OPTION_TYPE.DIARY:
        showClassDiaryView = true;
        break;
      case TEACHER_ROOM_OPTION_TYPE.ACTIVITY:
        showActivitiesView = true;
        break;
      case TEACHER_ROOM_OPTION_TYPE.CYCLE:
        showCycleClosureView = true;
        break;
      default:
        break;
    }

    setShowWeekCalendar(showWeekCalendarView);
    setShowOccurrences(showOccurrencesView);
    setShowClassPlan(showClassPlanView);
    setShowClassDiary(showClassDiaryView);
    setShowActivities(showActivitiesView);
    setShowCycleClosure(showCycleClosureView);
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const loadSchoolOpeningHours = () => {
    showLoading();
    const query = schoolWorkingDays();
    GraphQl(query, {})
      .then(({ findSchool }) => {
        hideLoading();
        if (findSchool) {
          const { startTime, finalTime } = findSchool;
          const [startHours, startMinutes] = startTime.split(':');
          const [finalHours, finalMinutes] = finalTime.split(':');
          setSchoolOpeningHours({
            ...findSchool,
            startHours,
            startMinutes,
            finalHours,
            finalMinutes,
          });
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadTeacher = () => {
    showLoading();
    const query = employeeListActive(true);
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        res.employeeListActive = res.employeeListActive.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }));
        const updatedTeachers = [...res.employeeListActive];
        setTeachers(updatedTeachers);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
        hideLoading();
      });
  };

  const employeeIsAdminById = () => {
    const query = getEmployeeIsAdmin();
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        setemployeeIsAdmin(res.getEmployeeIsAdmin);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
        hideLoading();
      });
  };

  const loadEventsByTeacherId = (teacherId) => {
    showLoading();
    const date = new Date();
    const query = professorScheduleGridByDateAndId(date, teacherId);
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        res.professorScheduleByDateAndId = res.professorScheduleByDateAndId.map(
          (item) => ({
            ...item,
            start: new Date(item.begin),
            end: new Date(item.end),
          })
        );
        if (res.professorScheduleByDateAndId === null) {
          setEvents([]);
        }
        setEvents(res.professorScheduleByDateAndId);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadEventsByDate = (date) => {
    showLoading();
    const id = 0;
    const query = professorScheduleGridByDateAndId(date, id);
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        res.professorScheduleByDateAndId = res.professorScheduleByDateAndId.map(
          (item) => ({
            ...item,
            start: new Date(item.begin),
            end: new Date(item.end),
          })
        );
        setEvents(res.professorScheduleByDateAndId);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const onChangeByFilterTeacher = (values) => {
    setshowByTeacherFilter(true);
    if (values) {
      setSelectedTeacher(values);
      loadEventsByTeacherId(values.id);
    }
  };

  const onChange = (date) => {
    if (teacherRoomMemoBox !== TEACHER_ROOM_OPTION_TYPE.GRADE) {
      setView({ type: TEACHER_ROOM_OPTION_TYPE.GRADE });
    }
    setSelectedDate(date);
    loadEventsByDate(date);
  };

  useEffect(() => {
    loadSchoolOpeningHours();
    loadEventsByDate();
    loadTeacher();
    employeeIsAdminById();
    setView({ type: teacherRoomMemoBox });
  }, []);

  return (
    <div className="teachers-room-container">
      <div className="column-wrapper">
        <div className="card__title">
          <h5 className="bold-text">{t('panels.sala-professor')}</h5>
        </div>
        <div className="navigation-wrapper-container">
          <div>
            {employeeIsAdmin && (
              <div className="container">
                <span className="card-title bold-text">
                  {t('communication.teacher')}
                </span>
                <h5 className="text-secondary bold-text mb-2">
                  {t('teachers-room.room-view')}
                </h5>
                <div className="label">
                  <OptionsSelection
                    name="teachers"
                    list={teachers}
                    selected={selectedTeacher || { value: 0 }}
                    handleChange={onChangeByFilterTeacher}
                  />
                </div>
              </div>
            )}
            <div className="navigations">
              {memoBoxes.map((memo) => (
                <button
                  type="button"
                  className="inbox__list-button"
                  key={uuid()}
                  onClick={() => setView(memo)}
                >
                  <MemoBox
                    title={memo.title}
                    selected={memo.type === teacherRoomMemoBox}
                  >
                    {memo.icon}
                  </MemoBox>
                </button>
              ))}
            </div>
          </div>
          <div className="month-calendar-container">
            <DatePicker
              selected={selectedDate}
              onChange={onChange}
              selectsRange
              inline
              locale={ptBR}
            />
          </div>
        </div>
      </div>
      <div className="content-wrapper">
        {showWeekCalendar && (
          <div className="week-calendar-container">
            <WeekCalendar
              events={events}
              memoBoxes={memoBoxes}
              history={history}
              startHours={schoolOpeningHours.startHours}
              startMinutes={schoolOpeningHours.startMinutes}
              finalHours={schoolOpeningHours.finalHours}
              finalMinutes={schoolOpeningHours.finalMinutes}
              defaultDateWeek={selectedDate}
            />
          </div>
        )}
        {showClassPlan && (
          <Communication
            title={t('general.plan-header')}
            hiddenMemoBox
            history={history}
            match={{ params: { type: COMMUNICATION_TYPE.PLAN } }}
          />
        )}
        {showOccurrences && (
          <Communication
            title={t('general.occurrences')}
            hiddenMemoBox
            history={history}
            match={{ params: { type: COMMUNICATION_TYPE.OCCURRENCE } }}
          />
        )}
        {showCycleClosure && <CycleClosing history={history} />}
        {showActivities && (
          <Communication
            title={t('communication.type-EXAM')}
            hiddenMemoBox
            history={history}
            match={{ params: { type: COMMUNICATION_TYPE.EXAM } }}
          />
        )}
        {showClassDiary && <ClassDiary history={history} />}
      </div>
    </div>
  );
};

TeachersRoom.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(TeachersRoom)
);
